import { supabase } from '../config/supabaseClient';

async function invokeFunction(name, body) {
  const { data, error } = await supabase.functions.invoke(name, { body });

  if (error) {
    throw new Error(error.message || `Failed to call ${name}`);
  }
  if (data?.error) {
    throw new Error(data.error);
  }

  return data;
}

export async function createRazorpayOrder(orderId, amount) {
  return invokeFunction('create-razorpay-order', { orderId, amount });
}

export async function verifyRazorpayPayment({
  orderId,
  razorpay_order_id,
  razorpay_payment_id,
  razorpay_signature,
}) {
  return invokeFunction('verify-razorpay-payment', {
    orderId,
    razorpay_order_id,
    razorpay_payment_id,
    razorpay_signature,
  });
}
